import { render } from "./announcement_details.vue?vue&type=template&id=d01eb070"
import script from "./announcement_details.vue?vue&type=script&lang=js"
export * from "./announcement_details.vue?vue&type=script&lang=js"

import exportComponent from "F:\\code\\ywym\\ydd-zht-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__